import { useEffect } from "react";

/**
 * /check — a marketing convenience URL. Anyone who sees "shescan.app/check"
 * on a badge, in an email, or on packaging gets sent directly into the app
 * at app.shescan.app/check. Uses window.location.replace so the redirect
 * does not leave a back-button trap.
 */
export default function CheckRedirect() {
  useEffect(() => {
    try {
      window.location.replace("https://app.shescan.app/check");
    } catch {
      /* fall back to a visible link below */
    }
  }, []);

  return (
    <div className="min-h-screen bg-paper text-ink font-sans flex items-center justify-center px-5">
      <p
        data-testid="check-redirect-text"
        className="font-mono text-[11px] uppercase tracking-[0.28em] text-ink-soft"
      >
        Redirecting to{" "}
        <a
          href="https://app.shescan.app/check"
          className="text-brand-orange underline underline-offset-4"
        >
          app.shescan.app/check
        </a>
        …
      </p>
    </div>
  );
}
